var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.collectionDocument)?_c('div',{staticClass:"collection"},[_c('blocks',{attrs:{"blocks":_vm.collectionDocument.blocks,"origin":_vm.origin,"entities":{ collection: _vm.collectionDocument, products: _vm.products, questionnaires: _vm.questionnaires },"is-on-top-of-page":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }